import * as actionTypes from "../../../actions/actionTypes";

const defaultCalendar = [
  {
    morningSlots: [],
    afternoonSlots: [],
    eveningSlots: [],
    workingDays: [],
    startDate: undefined,
    endDate: undefined,
  },
];

const practiceDetails = (
  state = {
    calendar: defaultCalendar,
    removedCalendar: [],
    removedSlots: [],
    dataChanged: false,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_PRACTICE_DETAILS:
      let setCalendar = defaultCalendar;
      if (action?.payload?.calendar?.length > 0 && Object.keys(action?.payload).length > 10){
        setCalendar = action?.payload?.calendar
      };

      if (Object.keys(action?.payload).length > 11) {
        return { ...state, dataChanged: true, ...action.payload, calendar: setCalendar };
      } else{
        return { ...state, dataChanged: true, ...action.payload };
      }

    case actionTypes.ADD_SLOTS: {
      const period = action.payload.period;
      const calId = action.payload.calId;
      const slots =
        (period === "morningSlots" && [
          ...state.calendar[calId].morningSlots,
        ]) ||
        (period === "afternoonSlots" && [
          ...state.calendar[calId].afternoonSlots,
        ]) ||
        (period === "eveningSlots" && [...state.calendar[calId].eveningSlots]);
      slots.push(
        (period === "morningSlots" && []) ||
          (period === "afternoonSlots" && []) ||
          (period === "eveningSlots" && [])
      );

      const cal = [...state.calendar];
      cal[calId] = {
        ...cal[calId],
        [period]: slots,
      };

      return { ...state, dataChanged: true, calendar: cal };
    }
    case actionTypes.SET_SLOTS: {
      const period = action.payload.period;
      const calId = action.payload.calId;
      const updatedSlots =
        (period === "morningSlots" && [
          ...state.calendar[calId].morningSlots,
        ]) ||
        (period === "afternoonSlots" && [
          ...state.calendar[calId].afternoonSlots,
        ]) ||
        (period === "eveningSlots" && [...state.calendar[calId].eveningSlots]);
      updatedSlots[action.payload.index] = {
        ...updatedSlots[action.payload.index],
        ...action.payload.data,
      };

      const cal = [...state.calendar];
      cal[calId] = {
        ...cal[calId],
        [period]: updatedSlots,
      };

      return { ...state, dataChanged: true, calendar: cal };
    }
    case actionTypes.REMOVE_SLOTS: {
      const period = action.payload.period;
      const calId = action.payload.calId;
      const updatedSlots =
        (period === "morningSlots" && [
          ...state.calendar[calId].morningSlots,
        ]) ||
        (period === "afternoonSlots" && [
          ...state.calendar[calId].afternoonSlots,
        ]) ||
        (period === "eveningSlots" && [...state.calendar[calId].eveningSlots]);

      const updated_removed_slot = [...state.removedSlots];
      updatedSlots[action.payload.index].id &&
        updated_removed_slot.push(updatedSlots[action.payload.index].id);

      updatedSlots.splice(action.payload.index, 1);

      const cal = [...state.calendar];

      if (updatedSlots.length > 0) {
        cal[calId] = {
          ...cal[calId],
          [period]: updatedSlots,
        };
      } else {
        cal[calId] = {
          ...cal[calId],
          [period]: [],
        };
      }

      return {
        ...state,
        dataChanged: true,
        calendar: cal,
        removedSlots: updated_removed_slot,
      };
    }

    case actionTypes.ADD_WORKING_DAYS: {
      const calId = action.payload.calId;
      const updatedObj = [...state.calendar[calId].workingDays];

      if (!updatedObj.includes(action.payload.data))
        updatedObj.push(action.payload.data);
      else updatedObj.splice(updatedObj.indexOf(action.payload.data), 1);

      const cal = [...state.calendar];
      cal[calId] = {
        ...cal[calId],
        workingDays: updatedObj,
      };

      return { ...state, dataChanged: true, calendar: cal };
    }

    case actionTypes.ADD_ACCEPT_UNTIL: {
      const calId = action.payload.calId;

      const cal = [...state.calendar];

      if (action.payload.date === "start") {
        cal[calId] = {
          ...cal[calId],
          startDate: action.payload.data,
        };
      } else {
        cal[calId] = {
          ...cal[calId],
          endDate: action.payload.data,
        };
      }

      return { ...state, dataChanged: true, calendar: cal };
    }

    case actionTypes.ADD_CALENDAR: {
      const calendars = [...state.calendar];
      calendars.push({
        morningSlots: [],
        afternoonSlots: [],
        eveningSlots: [],
        workingDays: [],
        startDate: undefined,
        endDate: undefined,
      });
      return { ...state, dataChanged: true, calendar: calendars };
    }

    case actionTypes.REMOVE_CALENDAR: {
      const calendars = [...state.calendar];
      const update_removed_calendar = [...state.removedCalendar];
      calendars[action.payload.calId].id &&
        update_removed_calendar.push(calendars[action.payload.calId].id);

      calendars.splice(action.payload.calId, 1);

      return {
        ...state,
        dataChanged: true,
        calendar: calendars,
        removedCalendar: update_removed_calendar,
      };
    }

    default:
      return state;
  }
};

export default practiceDetails;
